// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3N5m-","text":"SelectPayment_text__wN3hY","title":"SelectPayment_title__C1RM2","btn":"SelectPayment_btn__4ENrb"};